import React from "react";

import { useMatomo } from "@datapunt/matomo-tracker-react";

import { makeStyles } from "@material-ui/styles";
import { Divider, Grid, Typography } from "@material-ui/core";

import { useDocTitle } from "../../components/_common/DocTitle";
import TabsFAQ from "./TabsFAQ";
import TabsAbout from "./TabsAbout";

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        width: "100%",
    },
    tabTitle: {
        textTransform: "normal",
        fontWeight: 500,
    },
    tabImg: {
        maxWidth: 72,
    },
    bigTitle: {
        margin: theme.spacing(4, 4, 8, 4),
        textAlign: "center",
        justifyContent: "center",
    },
}));

const HomePage = (props) => {
    const classes = useStyles();
    useDocTitle("RSI: About");

    // Track page view
    const { trackPageView } = useMatomo();
    React.useEffect(() => {
        trackPageView();
        // eslint-disable-next-line
    }, []);

    return (
        <>
            <Grid container>
                <Grid item xs={12}>
                    <Typography variant="h4" className={classes.bigTitle} color="primary">
                        Informacje ogólne
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <TabsFAQ />
                    <Divider />
                </Grid>
                <Grid item xs={12}>
                    <TabsAbout />
                    <Divider />
                </Grid>
                <Grid item xs={12}></Grid>
                <Grid item xs={12}></Grid>
            </Grid>
        </>
    );
};

export default HomePage;
